export const isFalse = (value) => value === false;
export const isNotFalse = (value) => value !== false;
export const isPropertyFalse = (property) => (value) => value[property] === false;
export const isPropertyNotFalse = (property) => (value) => value[property] !== false;
export const arePropertiesFalse = (...properties) => (value) => properties.every((property) => value[property] === false);
export const arePropertiesNotFalse = (...properties) => (value) => properties.every((property) => value[property] !== false);
